<div class="flex flex-wrap h-full">
  <div
    class="hidden md:hidden lg:block lg:col-5 xl:col-5 p-0 relative video-container"
  >
    <auth-screen></auth-screen>
  </div>

  <div
    class="col-12 md:col-12 lg:hidden xl:hidden flex justify-content-center p-0"
  >
    <img class="mob-logo" [src]="images.blueLogo" alt="" />
  </div>
  <div
    class="col-12 md:col-12 lg:col-7 p-0 flex flex-column align-items-center lg:justify-content-center mt-8 lg:mt-0"
  >
    <div class=" flex align-items-center justify-content-center">
      <i class="icon-spovix-logo"></i>
    </div>
    <div class="my-2 flex flex-column align-items-center">
      <div class="heading mb-2">Response Saved Successfully.</div>
      <div class="heading-tagline">
        Your response has been successfully recorded. Log in to <br> Spovix using the button below for more details.
      </div>
      <div class="mt-6 mb-3 lg:px-2 w-full">
        <a [routerLink]="'/dashboard'">
          <button
            pButton
            class="w-full login-btn"
            type="button"
            
          >Login</button>
        </a>
       
      </div>
    </div>
    <div class="flex flex-wrap justify-content-center">
      <div class="col-12  flex align-items-center my-3">
        <hr class="w-full h-0" />
        <div class="mx-3" [ngStyle]="{ color: 'var(--neutral-300)' }">
          or
        </div> 
        <hr class="w-full h-0" />
      </div>

      <div
        class="col-12 lg:col-11 flex flex-row justify-content-center align-items-center"
      >
        <div class="trouble-label mr-1">Experiencing any issues?</div>
        <div>
          <a href="mailto:support@vantlogix.com" class="contact-label"
            >Contact Us</a
          >
        </div>
      </div>
    </div>
  </div>
</div>
